import React, { Fragment, useCallback } from "react";
import {
  useFileUploadRequest,
  useUpdateContentMediaFile,
  useUploadS3Direct,
} from "../contentServices";
import FileUploadInputButton from "../../../components/FileUploadInputButton";
import { useSnackAlert } from "../../../common/use-snackAlert";
import SnackAlert from "../../../components/SnackAlert";

const ContentMediaUpdateAction = ({ media }) => {
  //-- Manage the alert message
  const snackAlertHandler = useSnackAlert();
  const { showAlert } = snackAlertHandler;

  const fileUploadRequest = useFileUploadRequest();
  const uploadS3Direct = useUploadS3Direct();
  const updateContentMedia = useUpdateContentMediaFile();
  const handleUploadMediaUpdate = useCallback(
    async file => {
      console.log(file);
      const uploadRequest = {
        filename: file.name,
        fileType: "SUBMISSION",
        mimeType: file.type,
        size: file.size,
      };

      try {
        const fileUploadResponse = await fileUploadRequest.mutateAsync({
          data: uploadRequest,
        });
        console.log(fileUploadResponse);

        const fileResource = fileUploadResponse.fileResource;
        const fileUploadUrl = fileUploadResponse.uploadUrl;

        await uploadS3Direct.mutateAsync({
          url: fileUploadUrl,
          fileBlob: file,
        });
        console.log("File uploaded...");

        await updateContentMedia.mutateAsync({
          resourceIds: { mediaId: media.id },
          data: {
            contentType: media.type,
            file: fileResource,
          },
        });
        console.log("Update Request sent.");
        showAlert("success", ["Media file update request sent."]);
      } catch (err) {
        showAlert("error", [err.message]);
      }
    },
    [media, fileUploadRequest, uploadS3Direct, updateContentMedia, showAlert],
  );

  return (
    <Fragment>
      <SnackAlert handler={snackAlertHandler} />
      <FileUploadInputButton
        tooltip="Update Content File"
        onChange={handleUploadMediaUpdate}
      />
    </Fragment>
  );
};

export default ContentMediaUpdateAction;
